export default theme => ({
  a: {
    color: theme.palette.primary.main,
  },
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: 3600,
    backgroundColor: theme.palette.grey.light,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: 3600,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bgImg: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: 900,
    background: `no-repeat url(${theme.url('/blocks/b4-bg-left.png')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'left',
  },
  bgImg2: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    width: 750,
    background: `no-repeat url(${theme.url('/blocks/b4-bg-right.png')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'right',
  },
  blur: {
    position: 'absolute',
    zIndex: 1,
    background: 'rgba(255, 255, 255, 0)',
    backdropFilter: 'blur(12px)',
    height: '100%',
    width: 400,
  },
  square: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    backgroundColor: theme.palette.grey.light,
    height: '50%',
    width: 360,
  },
  square2: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.grey.light,
    height: '50%',
    width: 500,
  },
  mainTitle: {
    zIndex: 2,
    position: 'absolute',
    bottom: '8%',
    left: 100,
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      bottom: 0,
      left: 0,
      textAlign: 'right',
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
      color: theme.palette.primary.main,
    },
  },
  title: {
    zIndex: 2,
    position: 'absolute',
    top: '22%',
    left: 360,
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 0,
      left: 0,
      textAlign: 'left',
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  content: {
    zIndex: 3,
    position: 'relative',
    height: 'calc(100% - 120px)',
    width: 2690,
    left: 540,
    right: 250,
    margin: 60,
    '& em': {
      fontStyle: 'initial',
      fontSize: '2.5em',
      lineHeight: 0.8,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      left: 0,
      right: 0,
      margin: 0,
      height: 'initial',
      minHeight: '100%',
      paddingBottom: theme.spacing(2),
    },
  },
  col: {
    position: 'absolute',
    width: 400,
    marginLeft: 24,
    marginRight: 24,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      display: 'block',
      width: 'initial',
    },
  },
  col1: {
    top: '50%',
    height: '50%',
    left: 0,
    [theme.breakpoints.down('md')]: {
      top: 0,
      height: 'initial',
      left: 0,
    },
  },
  col2: {
    top: 0,
    height: '100%',
    left: 440,
    [theme.breakpoints.down('md')]: {
      top: 0,
      height: 'initial',
      left: 0,
    },
  },
  col3: {
    top: 0,
    height: '100%',
    left: 880,
    [theme.breakpoints.down('md')]: {
      top: 0,
      height: 'initial',
      left: 0,
    },
  },
  col4: {
    top: 0,
    height: '100%',
    left: 1320,
    '& > *': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down('md')]: {
      top: 0,
      height: 'initial',
      left: 0,
      '& > *': {
        display: 'block',
      },
    },
  },
  col5: {
    top: 0,
    height: '100%',
    left: 1760,
    [theme.breakpoints.down('md')]: {
      top: 0,
      height: 'initial',
      left: 0,
    },
  },
  col6: {
    top: '55%',
    height: '50%',
    left: 2200,
    [theme.breakpoints.down('md')]: {
      top: 0,
      height: 'initial',
      left: 0,
    },
  },
  infoLine: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(6),
    '& > *': {
      paddingTop: theme.spacing(8),
    },
    '& > *:first-child': {
      paddingTop: 0,
    },
    [theme.breakpoints.down('md')]: {
      display: 'inline-flex',
      gap: theme.spacing(1),
    },
  },
  bullet: {
    zIndex: 4,
    '&:before': {
      display: 'inline-block',
      position: 'absolute',
      left: '-2.5rem',
      top: '1rem',
      content: '""',
      borderRadius: '0.375rem',
      height: '0.75rem',
      width: '0.75rem',
    },
  },
  bulletPurple: {
    zIndex: 4,
    '&:before': {
      display: 'inline-block',
      position: 'absolute',
      left: '-2.5rem',
      top: '4rem',
      content: '""',
      borderRadius: '0.375rem',
      height: '0.75rem',
      width: '0.75rem',
      [theme.breakpoints.down('md')]: {
        top: '1rem',
      },
    },
  },
  bulletInfoline: {
    zIndex: 4,
    paddingTop: theme.spacing(8),
    '&:before': {
      display: 'inline-block',
      position: 'absolute',
      left: '-.4rem',
      top: '8rem',
      content: '""',
      borderRadius: '0.375rem',
      height: '0.75rem',
      width: '0.75rem',
    },
  },
  group: {
    zIndex: 4,
    paddingLeft: theme.spacing(4.2),
    borderLeft: `1px solid ${theme.palette.white.main}`,
  },
  text: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(6),
  },
  blue: {
    position: 'relative',
    '& b': {
      color: theme.palette.blue.main,
    },
    '& .bullet:before': {
      backgroundColor: theme.palette.blue.main,
    },
  },
  blueLight: {
    position: 'relative',
    '& b': {
      color: theme.palette.blue.light,
    },
    '& .bullet:before': {
      backgroundColor: theme.palette.blue.light,
    },
  },
  red: {
    position: 'relative',
    '& b': {
      color: theme.palette.red.main,
    },
    '& .bullet:before': {
      backgroundColor: theme.palette.red.main,
    },
  },
  purple: {
    position: 'relative',
    '& b': {
      color: theme.palette.purple.main,
    },
    '& .bullet:before': {
      backgroundColor: theme.palette.purple.main,
    },
  },
  purpleLight: {
    position: 'relative',
    '& b': {
      color: theme.palette.purple.light,
    },
    '& .bullet:before': {
      backgroundColor: theme.palette.purple.light,
    },
  },
  green: {
    position: 'relative',
    '& b': {
      color: theme.palette.green.dark,
    },
    '& .bullet:before': {
      backgroundColor: theme.palette.green.dark,
    },
  },
  bgText: {
    position: 'absolute',
    zIndex: -1,
    color: theme.palette.secondary.main,
    textTransform: 'initial',
  },
  bgText1: {
    fontSize: '3.3em',
    top: -theme.spacing(2),
    left: theme.spacing(4),
  },
  bgText2: {
    fontSize: '3.3em',
    top: -theme.spacing(2),
    left: theme.spacing(4),
  },
  bgText3: {
    fontSize: '3.3em',
    top: theme.spacing(6),
    left: -theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      top: theme.spacing(5),
    },
  },
  bgText4: {
    fontSize: '3.5em',
    top: -theme.spacing(5),
    left: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      top: -theme.spacing(2),
      left: theme.spacing(6),
    },
  },
  bgText5: {
    fontSize: '3.5em',
    top: -theme.spacing(4),
    left: theme.spacing(0),
  },
  bgText6: {
    fontSize: '4.1em',
    top: -theme.spacing(1),
    left: theme.spacing(2),
  },
  bgText7: {
    fontSize: '4.1em',
    top: theme.spacing(8),
    left: theme.spacing(2),
  },
  bgText8: {
    fontSize: '7.5em',
    top: -theme.spacing(11),
    left: -theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      top: -theme.spacing(9),
    },
  },
  bgText9: {
    fontSize: '7.5em',
    top: -theme.spacing(8),
    left: theme.spacing(18),
    [theme.breakpoints.down('md')]: {
      left: theme.spacing(12),
    },
  },
  bgText10: {
    fontSize: '5em',
    top: -theme.spacing(6),
    left: -theme.spacing(2),
  },
  bgText11: {
    fontSize: '5em',
    top: -theme.spacing(6),
    left: -theme.spacing(2),
  },
  bgText12: {
    fontSize: '4em',
    top: theme.spacing(1),
    left: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      top: -theme.spacing(4),
    },
  },
  bgText13: {
    fontSize: '4em',
    top: theme.spacing(1),
    left: theme.spacing(10),
    [theme.breakpoints.down('md')]: {
      top: -theme.spacing(4),
      left: theme.spacing(4),
    },
  },
  bgText14: {
    fontSize: '4em',
    top: theme.spacing(1),
    left: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      top: -theme.spacing(4),
      left: theme.spacing(4),
    },
  },
  bgText15: {
    fontSize: '4em',
    top: theme.spacing(1),
    left: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      top: -theme.spacing(3),
    },
  },
  bgText16: {
    fontSize: '5em',
    top: -theme.spacing(8),
    left: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      top: -theme.spacing(6),
      left: theme.spacing(1),
    },
  },
  bgText17: {
    fontSize: '5em',
    top: theme.spacing(0),
    left: theme.spacing(22),
    [theme.breakpoints.down('md')]: {
      top: theme.spacing(0),
      left: theme.spacing(12),
    },
  },
  bgText18: {
    fontSize: '4em',
    top: -theme.spacing(4),
    left: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      top: -theme.spacing(3),
    },
  },
  bgText19: {
    fontSize: '4em',
    top: theme.spacing(4),
    left: theme.spacing(22),
    [theme.breakpoints.down('md')]: {
      left: theme.spacing(16),
    },
  },
  bgText20: {
    fontSize: '5em',
    top: -theme.spacing(8),
    left: -theme.spacing(1),
  },
});
